import React, { useEffect, useState } from "react";
import PostCreateForm from "./PostCreateForm";
import FeedCard from "./FeedCard";
import { getAllPost } from "../../helpers/api/feed";
import { useSelector } from "react-redux";
import {
  Message,
  Or,
  PreloadState,
  isIterableArray,
} from "../UI/preloading/PreloadState";
import { Fragment } from "react";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import Swal from "sweetalert2";
import { deletePost } from "../../helpers/api/post";
import FullPagination from "../common/pagination/FullPagination";
import moment from "moment";

const FeedContent = () => {
  const {
    auth: {
      user: { role },
    },
    condominium: { selectedCondominium },
  } = useSelector((state) => state);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mutate, setMutate] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    lastPage: 1,
    perPage: 5,
    total: 0,
    condominium: role === "manager" && selectedCondominium,
  });
  const { currentPage, lastPage, perPage, total, condominium } = pagination;

  const { rol } = useSelector(state => state.auth.user);
  console.log(rol)

  useEffect(() => {
    const ac = new AbortController();
    const loadFeet = async () => {
      setIsLoading(true);
      const res = await getAllPost(pagination, { signal: ac.signal });

      if (!!res.data && !!res.links && !!res.meta) {
        setData(res.data);
        setPagination((prev) => {
          return {
            ...prev,
            currentPage: res.meta.current_page,
            lastPage: res.meta.last_page,
            perPage: res.meta.per_page,
            total: res.meta.total,
          };
        });
      }
      setIsLoading(false);
    };
    loadFeet();
    return () => {
      ac.abort();
      setData([]);
      setIsLoading(false);
    };
    // eslint-disable-next-line
  }, [currentPage, perPage, condominium, mutate]);

  const nextPage = () => {
    setPagination((prev) => {
      return { ...prev, currentPage: currentPage + 1 };
    });
  };

  const previousPage = () => {
    setPagination((prev) => {
      return { ...prev, currentPage: currentPage - 1 };
    });
  };

  const goToPage = (pageNumber) => {
    setPagination((prev) => {
      return { ...prev, currentPage: pageNumber };
    });
  };

  const _perPage = (pageNumber) => {
    setPagination((prev) => {
      return { ...prev, perPage: pageNumber };
    });
  };

  let date = "";

  const dropPost = (id) => {
    Swal.fire({
      title: "Seguro quieres eliminar este post?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Si, eliminar`,
      cancelButtonText: "no, dejar",
    }).then(async (result) => {
      if (result.value) {
        await deletePost(id)
          .then(({ code }) => {
            if (code === SUCCESS_RESPONSE.OK)
              Toast.fire({ title: "Post eliminado", type: "success" });
          })
          .catch((error) => handleErrorMessage(error));
      }
    });
  };

  return (
    <>
      {rol != "manager" && (<PostCreateForm mutate={setMutate} />)}
      <PreloadState cond={isIterableArray(data)} loading={isLoading}>
        <Or value={true}>
          <>
            {data.map((feed, index) => {
              if (date !== new Date(feed.created_at).getHours()) {
                date = new Date(feed.created_at).getHours();
                return (
                  <Fragment key={index.toString()}>
                    <Message
                      color="custom"
                      className="p-2"
                      value={true}
                      icon="info"
                    >
                      {moment(feed.created_at).fromNow()}
                    </Message>
                    <FeedCard {...feed} dropPost={dropPost} className="mb-3" />
                  </Fragment>
                );
              } else {
                return <FeedCard {...feed} key={index} className="mb-3" />;
              }
            })}
            {isIterableArray(data) && (
              <FullPagination
                nextPage={nextPage}
                prevPage={previousPage}
                goToPage={goToPage}
                meta={{
                  currentPage: currentPage,
                  lastPage: lastPage,
                  perPage: perPage,
                  total: total,
                  from: currentPage * perPage - perPage,
                  to: currentPage * perPage,
                }}
                className={"shadow-none"}
                posText={"publicaciones"}
                perPage={_perPage}
              />
            )}
          </>
        </Or>
      </PreloadState>
    </>
  );
};

export default FeedContent;
